import cn from 'classnames';
import { FC, HTMLProps, ReactNode } from 'react';
import s from './switch.module.css';

interface Props extends HTMLProps<HTMLDivElement> {
  isOn: boolean;
  onToggle: (state: boolean) => void;
  onLabel?: ReactNode;
  offLabel?: ReactNode;
}

export const Switch: FC<Props> = (props) => {
  const { isOn, onToggle, onLabel, offLabel, ...other } = props;

  return (
    <div className={cn(s.component, isOn && s.on)} onClick={() => onToggle(!isOn)} {...other}>
      <div className={s.handle} />

      {isOn ? onLabel : offLabel}
    </div>
  );
};
